import {html, css, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';

@customElement('webs-grid-row')
export class GridRow extends LitElement {

  static styles= css`
    :host {
      --grid-gutter-width-default: var(--gutter-width-default);
      --grid-gutter-width-extra-small: var(--gutter-width-extra-small);
      --grid-gutter-width-small: var(--gutter-width-small);
      --grid-gutter-width-medium: var(--gutter-width-medium);
      --grid-gutter-width-large: var(--gutter-width-large);
      --grid-gutter-width-extra-large: var(--gutter-width-extra-large);
    }

    :host { display: flex; flex: 0 1 auto; flex-direction: row; flex-wrap: wrap; }

    /* -- Default -- */
    :host { margin-left: calc(-1 * var(--grid-gutter-width-default) / 2); margin-right: calc(-1 * var(--grid-gutter-width-default) / 2); }

    :host([justify="center"]) { justify-content: center; }
    :host([justify="flex-start"]) { justify-content: flex-start; }
    :host([justify="flex-end"]) { justify-content: flex-end; }

    :host([align="stretch"]) { align-items: stretch; }
    :host([align="center"]) { align-items: center; }

    :host([reverse=""]) ::slotted(webs-grid-column:first-child) { order: 1; }

    /* -- Extra small -- */
    @media only screen and (min-width: 576px){
      :host { margin-left: calc(-1 * var(--grid-gutter-width-extra-small) / 2); margin-right: calc(-1 * var(--grid-gutter-width-extra-small) / 2); }

      :host([justify="center-xs"]) { justify-content: center; }
      :host([justify="flex-start-xs"]) { justify-content: flex-start; }
      :host([justify="flex-end-xs"]) { justify-content: flex-end; }

      :host([align="stretch-xs"]) { align-items: stretch; }
      :host([align="center-xs"]) { align-items: center; }

      :host([reverse="xs"]) ::slotted(webs-grid-column:first-child) { order: 1; }
    }

    /* -- Small -- */
    @media only screen and (min-width: 768px){
      :host { margin-left: calc(-1 * var(--grid-gutter-width-small) / 2); margin-right: calc(-1 * var(--grid-gutter-width-small) / 2); }

      :host([justify="center-sm"]) { justify-content: center; }
      :host([justify="flex-start-sm"]) { justify-content: flex-start; }
      :host([justify="flex-end-sm"]) { justify-content: flex-end; }

      :host([align="stretch-sm"]) { align-items: stretch; }
      :host([align="center-sm"]) { align-items: center; }

      :host([reverse="sm"]) ::slotted(webs-grid-column:first-child) { order: 1; }
    }

    /* -- Medium -- */
    @media only screen and (min-width: 992px){
      :host { margin-left: calc(-1 * var(--grid-gutter-width-medium) / 2); margin-right: calc(-1 * var(--grid-gutter-width-medium) / 2); }

      :host([justify="center-md"]) { justify-content: center; }
      :host([justify="flex-start-md"]) { justify-content: flex-start; }
      :host([justify="flex-end-md"]) { justify-content: flex-end; }

      :host([align="stretch-md"]) { align-items: stretch; }
      :host([align="center-md"]) { align-items: center; }

      :host([reverse="md"]) ::slotted(webs-grid-column:first-child) { order: 1; }
    }

    /* -- Large -- */
    @media only screen and (min-width: 1175px){
      :host { margin-left: calc(-1 * var(--grid-gutter-width-large) / 2); margin-right: calc(-1 * var(--grid-gutter-width-large) / 2); }

      :host([justify="center-lg"]) { justify-content: center; }
      :host([justify="flex-start-lg"]) { justify-content: flex-start; }
      :host([justify="flex-end-lg"]) { justify-content: flex-end; }

      :host([align="stretch-lg"]) { align-items: stretch; }
      :host([align="center-lg"]) { align-items: center; }

      :host([reverse="lg"]) ::slotted(webs-grid-column:first-child) { order: 1; }
    }

    /* -- Extra large -- */
    @media only screen and (min-width: 1440px){
      :host { margin-left: calc(-1 * var(--grid-gutter-width-extra-large) / 2); margin-right: calc(-1 * var(--grid-gutter-width-extra-large) / 2); }

      :host([justify="center-xl"]) { justify-content: center; }
      :host([justify="flex-start-xl"]) { justify-content: flex-start; }
      :host([justify="flex-end-xl"]) { justify-content: flex-end; }

      :host([align="stretch-xl"]) { align-items: stretch; }
      :host([align="center-xl"]) { align-items: center; }

      :host([reverse="xl"]) ::slotted(webs-grid-column:first-child) { order: 1; }
    }
  `;

  @property({attribute: 'classes'})
  rowClasses: string;

  protected render(): unknown {
    return html`<slot></slot>`
  }
}
